import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import Topbar from "../../components/Topbar/Topbar";
import DateRange from "../../components/DateRange/DateRange";
import { checkPermission } from "../redux/api/PermissionManager";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import { edit_icon, eye_icon, eye_primary } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import LogPopup from "./LogPopup";
import SosRespondPop from "./SosRespondPop";
import Select from "react-select";

// Helpers moved above component state so they can be used as initial values
const getTodayDateString = () => moment().format("YYYY-MM-DD");
const getCurrentTimeString = () => moment().format("HH:mm");

function SOSAlerts() {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const admin_details = JSON.parse(localStorage.getItem("admin_details"));
  const [propertiesList, setPropertiesList] = useState([]);
  const [selectedPoperty, setSelectedProperty] = useState("");

  const navigate = useNavigate();
  const [pagination, setPagination] = useState({});
  const [headerActive, setHeaderActive] = useState("Arrival SOS Queries");
  const [subheaderActive, setSubHeaderActive] = useState("SOS Alerts");
  const [subActive, setSubActive] = useState("Not Respond");
  const [showIssueModal, setShowIssueModal] = useState(false);
  const [isShowResponces, setIsShowResponces] = useState(false);
  const [selectedDate, setSelectedDate] = useState({
    from: "",
    to: "",
  });
  const [list, setList] = useState({
    "Arrival SOS Queries": {
      "SOS Alerts": {
        "Not Respond": [],
        Respond: [],
        Resolved: [],
      },
      "VOW Support Team": {
        "Not Respond": [],
        Respond: [],
        Resolved: [],
      },
    },
    "Room SOS Queries": {
      "SOS Alerts": {
        "Not Respond": [],
        Respond: [],
        Resolved: [],
      },
      "VOW Support Team": {
        "Not Respond": [],
        Respond: [],
        Resolved: [],
      },
    },
  });

  const columns = useMemo(() => {
    let base_columns = [
      {
        Header: "Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => {
          return (
            <p
              onClick={() => {
                navigate("/booking-list-view", {
                  state: {
                    type: "edit",
                    booking_id: row.original?.user_booking_id,
                  },
                });
              }}
              className="light-blue pointer"
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Ticket ID",
        accessor: "request_code",
        Cell: ({ value, row }) => {
          return <p className="">{value}</p>;
        },
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div
              onClick={() => {
                navigate("/property-details", {
                  state: {
                    id: row.original?.property,
                    category_id: row.original?.property_category_id,
                  },
                });
              }}
              className="center text-nowrap"
            >
              <p className="light-blue pointer">{value}</p>
              <p className="light-blue pointer">
                {row.original?.property_code}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Raised Date & Time",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY hh:mm A")}</p>;
        },
      },
      {
        Header: "Users Queries",
        accessor: "messages",
        Cell: ({ value, row }) => {
          return (
            <p style={{ maxWidth: "200px", overflow: "auto" }}>
              {String(value?.[0])}
            </p>
          );
        },
      },

      {
        Header: "Attempts",
        accessor: "status",
        Cell: ({ value, row }) => {
          return <p>{String(value).padStart(2, 0)}</p>;
        },
      },
    ];
    let log = {
      Header: "Log",
      accessor: "",
      Cell: ({ value, row }) => {
        let val = row?.original?.alert_responses?.[0];
        let showLog = Boolean(val?.receptionist || val?.owner || val?.admin);
        return showLog ? (
          <div
            onClick={() => {
              setIsShowResponces(row?.original?.alert_responses);
            }}
          >
            <img src={eye_primary} />
          </div>
        ) : (
          <p>-</p>
        );
      },
    };

    let hotel_responded = [
      {
        Header: "Response by hotel",
        accessor: "",
        Cell: ({ value, row }) => {
          let val = row.original?.alert_responses?.[0];
          let responded_by = !val
            ? "-"
            : val?.receptionist
              ? "Receptionist"
              : val?.owner
                ? "Owner"
                : "Admin";

          return <p>{responded_by}</p>;
        },
      },
      {
        Header: "Response date &time",
        accessor: "alert_responses",
        Cell: ({ value, row }) => {
          return (
            <p>{moment(value?.[0]?.updated_at).format("DD/MM/YYYY hh:mm A")}</p>
          );
        },
      },
    ];

    let vow_not_response = [
      {
        Header: "Reporting Date & Time",
        accessor: "alert_responses",
        Cell: ({ value, row }) => {
          return (
            <p>{moment(value?.[0]?.updated_at).format("DD/MM/YYYY hh:mm A")}</p>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <button
              onClick={() => setShowIssueModal(row.original)}
              className="cust-btn"
            >
              <img src={eye_primary} alt="eye" />
            </button>
          );
        },
      },
    ];
    let vow_responded = [
      {
        Header: "Admin",
        accessor: "",
        Cell: ({ value, row }) => {
          let responded_by = row.original?.alert_responses?.[0]?.admin_details;
          return <p>{responded_by?.name}</p>;
        },
      },
      {
        Header: "Response Date & Time",
        accessor: "alert_responses",
        Cell: ({ value, row }) => {
          return (
            <p>{moment(value?.[0]?.updated_at).format("DD/MM/YYYY hh:mm A")}</p>
          );
        },
      },
    ];
    return {
      "SOS Alerts": {
        "Not Respond": [...base_columns, log],
        Respond: [...base_columns, ...hotel_responded, log],
        Resolved: [...base_columns, ...hotel_responded, log],
      },
      "VOW Support Team": {
        "Not Respond": [...base_columns, ...vow_not_response, log],
        Respond: [...base_columns, ...vow_responded, log],
        Resolved: [...base_columns, ...vow_responded, log],
      },
    };
  }, []);

  const getList = async (page = 1) => {
    let payload = {
      sos_type: headerActive === "Arrival SOS Queries" ? 1 : 2, //=> Manditory 1 - Arrival, 2 - Checkin
      booking_type: subheaderActive === "SOS Alerts" ? 1 : 2, //=> Manditory # 1 - Hotel Sos. 2 - Admin Sos
      sos_status:
        subActive === "Not Respond" ? 1 : subActive === "Resolved" ? 3 : 2, //=> Manditory # 1 - Not Responded, 2 - Responded, 3 - resolved
      from_date: selectedDate.from ?? undefined, //=> Optional
      to_date: selectedDate.to ?? undefined, //=> Optional
      property_id: selectedPoperty?.value ?? undefined, //=> Optional
    };
    let res = await post(URLS.SOS_ALERTS_LIST + "?page=" + page, payload);
    if (res?.status === "success") {
      setList((prev) => ({
        ...prev,
        [headerActive]: {
          ...prev[headerActive],
          [subheaderActive]: {
            ...prev?.[headerActive]?.[subheaderActive],
            [subActive]: res?.data ?? [],
          },
        },
      }));
      setPagination((prev) => ({
        ...prev,
        [headerActive]: {
          ...prev[headerActive],
          [subheaderActive]: {
            ...prev?.[headerActive]?.[subheaderActive],
            [subActive]: {
              current_page: page,
              last_page: res?.total_pages,
            },
          },
        },
      }));
    }
  };

    const getProperties = async () => {
      const res = await get(URLS.PROPERTIES_DROPDOWN);
      console.log("properties dropdown", res);
      if (res?.status === "success") {
        const modifiedList = res?.data?.map((item) => {
          return { value: item?.id, label: item?.name };
        });
        setPropertiesList(modifiedList);
      }
    };

    useEffect(() => {
      getProperties();
    }, []);

  useEffect(() => {
    getList(
      pagination?.[headerActive]?.[subheaderActive]?.[subActive]?.current_page,
    );
  }, [headerActive, subheaderActive, subActive, selectedPoperty]);

  useEffect(() => {
    let { from, to } = selectedDate;
    if ((from && to) || (!from && !to))
      getList(
        pagination?.[headerActive]?.[subheaderActive]?.[subActive]
          ?.current_page,
      );
  }, [selectedDate]);

  return (
    <div>
      <Topbar header={"SOS Alert"} />
      <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
        {["Arrival SOS Queries", "Room SOS Queries"].map((ele) => {
          return (
            <div
              key={ele}
              style={{
                background: headerActive == ele ? "#78788029" : "",
                width: "40%",
                textAlign: "center",
                padding: "10px 20px",
                borderRadius: 8,
                cursor: "pointer",
              }}
              onClick={() => setHeaderActive(ele)}
            >
              <p>{ele}</p>
            </div>
          );
        })}
      </div>
      <div
        style={{
          marginTop: 30,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 10,
          }}
        >
          {["SOS Alerts", "VOW Support Team"].map((ele) => {
            return (
              <div
                key={ele}
                style={{
                  background: subheaderActive == ele ? "#AE55F5" : "#78788029",
                  textAlign: "center",
                  padding: "10px 20px",
                  borderRadius: 8,
                  cursor: "pointer",
                }}
                onClick={() => setSubHeaderActive(ele)}
              >
                <p style={{ color: subheaderActive == ele ? "#fff" : "#000" }}>
                  {ele}
                </p>
              </div>
            );
          })}
        </div>
        <div className="d-flex gap-2 ac-jb">
          <Select
            className="location-search"
            options={propertiesList}
            value={selectedPoperty}
            onChange={(e) => {
              setSelectedProperty(e);
            }}
            isClearable
            placeholder={"Property"}
          />
          <DateRange
            setFromDate={(from) =>
              setSelectedDate((prev) => ({ ...prev, from: from }))
            }
            setToDate={(to) => setSelectedDate((prev) => ({ ...prev, to: to }))}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 10,
          marginTop: 20,
        }}
      >
        {["Not Respond", "Respond", "Resolved"].map((ele) => {
          return (
            <div
              key={ele}
              style={{
                background: subActive == ele ? "#AE55F5" : "#78788029",
                textAlign: "center",
                padding: "10px 20px",
                borderRadius: 8,
                cursor: "pointer",
              }}
              onClick={() => setSubActive(ele)}
            >
              <p style={{ color: subActive == ele ? "#fff" : "#000" }}>{ele}</p>
            </div>
          );
        })}
      </div>
      <Table
        columns={columns?.[subheaderActive]?.[subActive]}
        setPageno={(page) => {
          let pageCount =
            pagination?.[headerActive]?.[subheaderActive]?.[subActive] ?? {};
          if (pageCount?.current_page < pageCount?.last_page) getList(page);
        }}
        pagecount={
          pagination?.[headerActive]?.[subheaderActive]?.[subActive] ?? {}
        }
        data={list?.[headerActive]?.[subheaderActive]?.[subActive] ?? []}
        show={true}
      />

      {showIssueModal && (
        <SosRespondPop
          onclose={(from) => {
            if (from === "api")
              getList(
                pagination?.[headerActive]?.[subheaderActive]?.[subActive]
                  ?.current_page,
              );
            setShowIssueModal(false);
          }}
          data={showIssueModal}
        />
      )}

      {isShowResponces && (
        <LogPopup
          setShowResponse={setIsShowResponces}
          showResponse={isShowResponces}
        />
      )}
    </div>
  );
}

export default SOSAlerts;
